import { lvlCfg, placement, info, field, SHAPE, helperCfg } from ".";
import { CELL_STATE } from "../cell";
import { POSITIONS } from "../info";

export const CLASSIC_LEVELS = [
  // easy
  lvlCfg({
    // fieldGeometries: field(SHAPE.HEX),
    placements: [
      placement(CELL_STATE.BLOCKED, SHAPE.RANDOM, 20),
      //   placement(CELL_STATE.CENTER, SHAPE.RANDOM, 16),
      //   placement(CELL_STATE.DROP, SHAPE.RANDOM, 16),
      placement(CELL_STATE.FREE, SHAPE.POINT, [0, 0]),
    ],
    info: info(
      [7, 7],
      "Welcome! Your task is to create a safe path and prevent the curious black cat from wandering off the playing field. Ready to be a feline hero? Let's get started!"
    ),
  }),
  // medium
  lvlCfg({
    placements: [
      placement(CELL_STATE.BLOCKED, SHAPE.RANDOM, 10),
      placement(CELL_STATE.FREE, SHAPE.POINT, [0, 0]),
    ],
  }),
  // hard
  lvlCfg({
    placements: [
      placement(CELL_STATE.BLOCKED, SHAPE.RANDOM, 5),
      placement(CELL_STATE.FREE, SHAPE.POINT, [0, 0]),
    ],
  }),
];

export const LEVELS = [
  // lvlCfg({
  //     fieldSize: 11,
  //     // fieldSize: 8,
  //     fieldGeometries: field(SHAPE.HEX_2),
  //     placements: [
  //       placement(CELL_STATE.BLOCKED, SHAPE.RANDOM, 16),
  //         placement(CELL_STATE.CENTER, SHAPE.RANDOM, 16),
  //         placement(CELL_STATE.DROP, SHAPE.RANDOM, 16),
  //       placement(CELL_STATE.FREE, SHAPE.POINT, [0, 0]),
  //     //   placement(CELL_STATE.ERASE, SHAPE.RECTANGLE_H, [0, 6]),
  //     placement(CELL_STATE.ERASE, SHAPE.LINE_H, 4),
  //     placement(CELL_STATE.OUTSIDE, SHAPE.LINE_H, 3),
  //     placement(CELL_STATE.ERASE, SHAPE.LINE_H, -4),
  //       placement(CELL_STATE.OUTSIDE, SHAPE.LINE_H, -3),
  //     ],
  //   }),
  // lvlCfg({
  //     fieldSize: 7,
  //     fieldGeometries: field(SHAPE.HEX),
  //     placements: [
  //       placement(CELL_STATE.NON_BLOCKABLE, SHAPE.H_LINE, -1),
  //       placement(CELL_STATE.FREE, SHAPE.POINT, [0, -1]),
  //       placement(CELL_STATE.CENTER, SHAPE.POINT, [0, -1]),
  //     ],
  //   }),
  /* Level 1-3: Basic Gameplay
       During these levels, the player learns about the basic mechanics of the
       game, including blocking cells and predicting cat movements. The grid size
       is small and only one cat is present. */
  // 1
  lvlCfg({
    fieldSize: 13,
    fieldGeometries: field(SHAPE.HEX),
    placements: [
      placement(CELL_STATE.BLOCKED, SHAPE.H_LINE, -1),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_ANGLE, -1),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_ANGLE, 7),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_ANGLE_INV, -1),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_ANGLE_INV, 7),
    ],
    helper: helperCfg({
      showPointer: true,
      placement: placement(
        null,
        [SHAPE.POINT, SHAPE.POINT, SHAPE.POINT],
        [
          [-1, 4],
          [0, 4],
          [1, 4],
        ]
      ),
    }),
    info: info(
      [6, 6],
      "Your ultimate mission is to rescue the black cat from escaping the playing field. You can accomplish this by strategically blocking certain fields and preventing her from leaving. Good luck!"
    ),
  }),
  // 2
  lvlCfg({
    fieldSize: 13,
    placements: [placement(CELL_STATE.BLOCKED, SHAPE.GRID_2, 0)],
  }),
  // 3
  lvlCfg({
    fieldSize: 13,
    placements: [
      placement(CELL_STATE.BLOCKED, SHAPE.DIAG, 0),
      placement(CELL_STATE.BLOCKED, SHAPE.DIAG_2, 0),
      placement(CELL_STATE.FREE, SHAPE.POINT, [0, 0]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [4, 0]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-4, 0]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-4, -2]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-4, 2]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [0, 4]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [0, -4]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [4, -1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [4, 1]),
    ],
  }),
  // 4
  lvlCfg({
    fieldGeometries: field(SHAPE.TRIANGLE),
    fieldSize: 15,
    catPlacement: placement(null, [SHAPE.POINT], [[0, 3]]),
    placements: [
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [0, 5]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-1, 4]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [0, 4]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-1, 3]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [1, 3]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [0, 3]),

      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [5, -5]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [4, -5]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [4, -4]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [4, -3]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [3, -5]),

      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-5, -5]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-4, -5]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-5, -4]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-4, -3]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-3, -5]),

      placement(CELL_STATE.FREE, SHAPE.POINT, [0, -1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [1, -1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-1, -1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [0, -2]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-1, -2]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [0, 3]),
    ],
  }),
  // 5
  lvlCfg({
    catPlacement: placement(null, [SHAPE.POINT], [[0, -1]]),
    fieldGeometries: field(
      [SHAPE.TRIANGLE_INV, SHAPE.HEX],
      [
        [3, 3],
        [0, 0],
      ]
    ),
    placements: [
      placement(CELL_STATE.BLOCKED, SHAPE.DOT_LINE_2, [2, 1]),
      placement(CELL_STATE.BLOCKED, SHAPE.DOT_LINE_2, [12, 1]),
      // placement(CELL_STATE.BLOCKED, SHAPE.DOT_LINE_2, [-5, 1]),
      //   placement(CELL_STATE.FREE, SHAPE.POINT, [0, 5]),
      //   placement(CELL_STATE.FREE, SHAPE.POINT, [0, -5]),
      //   placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-1, 5]),
      //   placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-2, 5]),
    //   placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-5, 0]),
    //   placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-4, 1]),
    //   placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-4, -1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [4, 0]),
    //   placement(CELL_STATE.BLOCKED, SHAPE.POINT, [4, 1]),
    //   placement(CELL_STATE.BLOCKED, SHAPE.POINT, [4, -1]),
    ],
  }),
  /* Level 4-6: Advanced Gameplay
       These levels introduce more complex grid layouts, additional cats, and/or
       pre-blocked cells. The aim here is to develop the player's strategic
       planning skills. */
  // 6
  /* Level 7-10: Mastery
       In these levels, the grid gets even larger and the game introduces more
       challenging elements like more cats, complex layouts, and more pre-blocked
       cells. The goal is for players to demonstrate that they have mastered the
       basic mechanics and are ready for the additional challenge. */
  // 6
  lvlCfg({
    fieldSize: 17,
    fieldGeometries: field(SHAPE.HEX_2),
    catPlacement: placement(
      null,
      [
        SHAPE.POINT,
        // SHAPE.POINT
      ],
      [
        [-2, -1],
        // [-2, -2],
      ]
    ),
    placements: [
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.DIAG_2, 2),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.DIAG_2, 3),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.DIAG_2, 4),
      placement(CELL_STATE.BLOCKED, SHAPE.DIAG, 2),
      placement(CELL_STATE.BLOCKED, SHAPE.DIAG, 3),
      placement(CELL_STATE.BLOCKED, SHAPE.DIAG, 4),
      placement(CELL_STATE.BLOCKED, SHAPE.DIAG, -2),
      placement(CELL_STATE.BLOCKED, SHAPE.DIAG, -3),
      placement(CELL_STATE.BLOCKED, SHAPE.DIAG, -4),
      placement(CELL_STATE.FREE, SHAPE.DIAG_2, -2),
      placement(CELL_STATE.FREE, SHAPE.DIAG_2, -3),
      placement(CELL_STATE.FREE, SHAPE.DIAG_2, -4),
      placement(CELL_STATE.FREE, SHAPE.DIAG_2, 2 + 6),
      placement(CELL_STATE.FREE, SHAPE.DIAG_2, 3 + 6),
      placement(CELL_STATE.FREE, SHAPE.DIAG_2, 4 + 6),
      placement(CELL_STATE.FREE, SHAPE.DIAG_2, 5 + 6),
      placement(CELL_STATE.FREE, SHAPE.DIAG_2, -2 - 6),
      placement(CELL_STATE.FREE, SHAPE.DIAG_2, -3 - 6),
      placement(CELL_STATE.FREE, SHAPE.DIAG_2, -4 - 6),
      placement(CELL_STATE.FREE, SHAPE.DIAG_2, -5 - 6),
      //   placement(CELL_STATE.OUTSIDE, SHAPE.HEX_OUTLINE, [0, 0, 7]),
      //   placement(CELL_STATE.OUTSIDE, SHAPE.HEX_OUTLINE, [0, 0, 8]),
      //   placement(CELL_STATE.OUTSIDE, SHAPE.LINE_H, 7),
    ],
    info: info(
      [9, 9],
      "Meet the Non-Blockable Fields! These special fields cannot be blocked. The cat can walk on them, but you can't block them. It's a real challenge, but you can do it! Good luck!"
    ),
  }),
  // 7
  lvlCfg({
    catPlacement: placement(null, [SHAPE.POINT], [[-1, 0]]),
    placements: [
      placement(CELL_STATE.NON_BLOCKABLE, [SHAPE.POINT], [[-3, 0]]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.BLOCK_L, [20, 5]),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_ANGLE, 2),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_ANGLE_INV, 2),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-2, 0]),
      placement(CELL_STATE.BLOCKED, SHAPE.DOT_LINE, [0, 5]),
      placement(CELL_STATE.BLOCKED, SHAPE.DOT_LINE, [1, 12]),
    ],
    helper: helperCfg({
      maxSteps: 0,
      placement: placement(null, [SHAPE.POINT], [[-2, 0]]),
    }),
  }),
  // 8
  lvlCfg({
    fieldSize: 13,
    fieldGeometries: field(SHAPE.HEX_2),
    placements: [
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.HEX_3, [0, 0, 5]),
      placement(CELL_STATE.FREE, SHAPE.HEX_OUTLINE, [0, 0, 4]),
      placement(CELL_STATE.FREE, SHAPE.HEX_OUTLINE, [0, 0, 2]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [0, 0]),
      //   placement(CELL_STATE.BLOCKED, SHAPE.POINT, [6, 0]),
      //   placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-6, 0]),
      //   placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-3, -6]),
      //   placement(CELL_STATE.BLOCKED, SHAPE.POINT, [3, -6]),
      //   placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-3, 6]),
      //   placement(CELL_STATE.BLOCKED, SHAPE.POINT, [3, 6]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [4, 0]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-4, 0]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-2, -4]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [2, -4]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-2, 4]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [2, 4]),
    ],
    helper: helperCfg({
      maxSteps: 3,
      placement: placement(
        null,
        [
          SHAPE.POINT,
          SHAPE.POINT,
          SHAPE.POINT,
          SHAPE.POINT,
          SHAPE.POINT,
          SHAPE.POINT,
          SHAPE.POINT,
          SHAPE.POINT,
          SHAPE.POINT,
          SHAPE.POINT,
          SHAPE.POINT,
          SHAPE.POINT,
          SHAPE.POINT,
          SHAPE.POINT,
          SHAPE.POINT,
          SHAPE.POINT,
          SHAPE.POINT,
          SHAPE.POINT,
        ],
        [
          [1, 4],
          [0, 4],
          [-1, 4],

          [-3, 3],
          [-3, 2],
          [-4, 1],

          [2, 3],
          [3, 2],
          [3, 1],

          [2, -3],
          [3, -2],
          [3, -1],

          [-3, -3],
          [-3, -2],
          [-4, -1],

          [-1, -4],
          [0, -4],
          [1, -4],
        ]
      ),
    }),
  }),
  // 7
  lvlCfg({
    fieldSize: 13,
    catPlacement: placement(
      null,
      [SHAPE.POINT, SHAPE.POINT],
      [
        [1, 0],
        [-1, 0],
      ]
    ),
    placements: [
      placement(CELL_STATE.BLOCKED, SHAPE.DENSE_GRID, 0),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [0, 1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [2, 0]),
    ],
    info: info(
      [6, 6],
      "Double trouble! Now there are two cats to contain. Be strategic, block their paths, and prevent them from escaping. It's a real cat-and-mouse game. Good luck!"
    ),
    helper: helperCfg({
      maxSteps: 0,
      placement: placement(null, [SHAPE.POINT], [[0, -1]]),
    }),
  }),
  // 8
  lvlCfg({
    fieldSize: 13,
    fieldGeometries: field(SHAPE.HEX),
    catPlacement: placement(
      null,
      [SHAPE.POINT, SHAPE.POINT],
      [
        [1, -1],
        [-2, 3],
      ]
    ),
    placements: [
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_ANGLE, -1),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_ANGLE, 1),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-1, 4]),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_ANGLE, 6),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [2, 4]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-2, -4]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [0, 4]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [2, -1]),
    ],
    helper: helperCfg({
      maxSteps: 0,
      placement: placement(null, [SHAPE.POINT], [[2, -1]]),
    }),
  }),
  // 9
  lvlCfg({
    fieldSize: 15,
    fieldGeometries: field(
      [SHAPE.RECTANGLE_V, SHAPE.RECTANGLE_H],
      [
        [3, 0],
        [3, 3],
      ]
    ),
    catPlacement: placement(
      null,
      [SHAPE.POINT, SHAPE.POINT, SHAPE.POINT, SHAPE.POINT],
      [
        [2, -3],
        [-2, -3],
        [0, 0],
        [0, -3],
      ]
    ),
    placements: [
      placement(CELL_STATE.BLOCKED, SHAPE.V_LINE, -2),
      placement(CELL_STATE.BLOCKED, SHAPE.V_LINE, 2),
      placement(CELL_STATE.BLOCKED, SHAPE.H_LINE, -5),
      placement(CELL_STATE.BLOCKED, SHAPE.H_LINE, -1),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-5, -3]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [5, -3]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [0, 5]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [2, -3]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-2, -3]),
    ],
    helper: helperCfg({
      maxSteps: 3,
      placement: placement(
        null,
        [SHAPE.POINT, SHAPE.POINT, SHAPE.POINT, SHAPE.POINT],
        [
          [-5, -4],
          [5, -4],
          [-5, -2],
          [5, -2],
        ]
      ),
    }),
  }),
  // 10
  lvlCfg({
    fieldGeometries: field([SHAPE.TRIANGLE, SHAPE.TRIANGLE_INV], [null, null]),
    catPlacement: placement(
      null,
      [SHAPE.POINT, SHAPE.POINT],
      [
        [0, -1],
        [-1, 2],
      ]
    ),
    placements: [
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_ANGLE, 1),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_ANGLE, 6),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_ANGLE_INV, 1),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_H, -5),
      // placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [1, 0]),
      // placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [2, 1]),
      // placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [2, 2]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [3, 3]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [3, 4]),
      // placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [4, 5]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [0, 4]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [1, 5]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [3, -1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [3, -2]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [4, -3]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [4, -4]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [5, -5]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-1, 5]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-2, 5]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-3, 5]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-4, 5]),
      //   placement(CELL_STATE.BLOCKED, SHAPE.H_LINE, -5),
      //   placement(CELL_STATE.BLOCKED, SHAPE.H_LINE, -1),
      //   placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-5, -3]),
      //   placement(CELL_STATE.BLOCKED, SHAPE.POINT, [5, -3]),
      //   placement(CELL_STATE.BLOCKED, SHAPE.POINT, [0, 5]),
      //   placement(CELL_STATE.FREE, SHAPE.POINT, [2, -3]),
      //   placement(CELL_STATE.FREE, SHAPE.POINT, [-2, -3]),
    ],
    helper: helperCfg({
      showPointer: true,
      maxSteps: 3,
      loop: false,
      placement: placement(
        null,
        [SHAPE.POINT, SHAPE.POINT, SHAPE.POINT, SHAPE.POINT],
        [
          [0, 3],
          [1, 3],
          [1, 4],
          [2, 5],
        ]
      ),
    }),
  }),
  /* Level 9 and onwards: Special Boosters
       After level 8, start introducing special boosters or power-ups. This is a
       point at which players may be looking for new strategies or assistance to
       help them through more difficult levels. */
  // 9 // 11
  lvlCfg({
    fieldSize: 15,
    info: info(
      [4, 6],
      "Meet the Scatter Blocker! This special booster will randomly block several fields whenever the cat walks on it. It's a game of chance that could turn the tide in your favor. Will fortune favor you?",
      0,
      POSITIONS.TOP
    ),
    placements: [
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [1, 1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [0, -1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [1, -1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-1, 0]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [1, 0]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-1, 1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-2, 2]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [1, 1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [0, 2]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [0, 3]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [0, 1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-1, 2]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [-1, 3]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [0, 4]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-1, 4]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-2, 4]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-2, 3]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-3, 2]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [1, 3]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [1, 2]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [2, 1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-2, 0]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-2, 1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [2, 0]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [2, -1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [0, -2]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [1, -2]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-1, -2]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-1, -1]),
    ],
    helper: helperCfg({
      maxSteps: 6,
      placement: placement(
        null,
        [
          SHAPE.POINT,
          SHAPE.POINT,
          SHAPE.POINT,
          SHAPE.POINT,
          SHAPE.POINT,
          SHAPE.POINT,
          SHAPE.POINT,
        ],
        [
          [-4, 2],
          [-3, 3],
          [-3, 4],
          [-2, 5],
          [-1, 5],
          [0, 5],
          [1, 5],
        ]
      ),
    }),
  }),
  lvlCfg({
    fieldSize: 13,
    fieldGeometries: field(SHAPE.HEX_2),
    placements: [
      //   placement(CELL_STATE.DROP, SHAPE.HEX_3, [0, 0, 5]),
      //   placement(CELL_STATE.FREE, SHAPE.HEX_OUTLINE, [0, 0, 4]),
      placement(CELL_STATE.DROP, SHAPE.HEX_OUTLINE, [0, 0, 2]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.HEX_OUTLINE, [0, 0, 3]),
      //   placement(CELL_STATE.FREE, SHAPE.POINT, [0, 0]),
      //   placement(CELL_STATE.BLOCKED, SHAPE.POINT, [6, 0]),
      //   placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-6, 0]),
      //   placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-3, -6]),
      //   placement(CELL_STATE.BLOCKED, SHAPE.POINT, [3, -6]),
      //   placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-3, 6]),
      //   placement(CELL_STATE.BLOCKED, SHAPE.POINT, [3, 6]),
      //   placement(CELL_STATE.BLOCKED, SHAPE.POINT, [4, 0]),
      //   placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-4, 0]),
      //   placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-2, -4]),
      //   placement(CELL_STATE.BLOCKED, SHAPE.POINT, [2, -4]),
      //   placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-2, 4]),
      //   placement(CELL_STATE.BLOCKED, SHAPE.POINT, [2, 4]),
    ],
  }),
  lvlCfg({
    fieldSize: 13,
    fieldGeometries: field([SHAPE.TRIANGLE_INV], [null, null]),
    catPlacement: placement(null, [SHAPE.POINT], [[0, 2]]),
    placements: [
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_ANGLE, 1),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_ANGLE_INV, 5),
      placement(CELL_STATE.DROP, SHAPE.LINE_ANGLE_INV, 6),
      placement(CELL_STATE.DROP, SHAPE.LINE_ANGLE, 0),
      placement(CELL_STATE.DROP, SHAPE.LINE_ANGLE, 5),
      placement(CELL_STATE.DROP, SHAPE.LINE_ANGLE_INV, 1),
      placement(CELL_STATE.FREE, SHAPE.POINT, [0, -4]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [0, -3]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-1, -3]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-1, -2]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [1, -2]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-2, -1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [1, -1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-4, -4]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [4, -4]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-4, -3]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [3, -3]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-3, -2]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [3, -2]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-3, -1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [2, -1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [0, 2]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [0, 1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-1, 1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [0, 0]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-1, 0]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [1, 0]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-1, -1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [0, -1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [0, -2]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-3, 3]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-2, 4]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-3, 4]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [2, 3]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [2, 4]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [3, 4]),

      //   placement(CELL_STATE.FREE, SHAPE.POINT, [0, 5]),
      //   placement(CELL_STATE.FREE, SHAPE.POINT, [-1, 4]),
      //   placement(CELL_STATE.FREE, SHAPE.POINT, [-1, 3]),
      //   placement(CELL_STATE.FREE, SHAPE.POINT, [-2, 2]),
      //   placement(CELL_STATE.FREE, SHAPE.POINT, [1, 2]),
      //   placement(CELL_STATE.FREE, SHAPE.POINT, [1, 3]),
      //   placement(CELL_STATE.FREE, SHAPE.POINT, [0, 4]),
      //   placement(CELL_STATE.CENTER, SHAPE.POINT, [3, 4]),
      //   placement(CELL_STATE.CENTER, SHAPE.POINT, [-3, 4]),
      //   placement(CELL_STATE.DROP, SHAPE.POINT, [0, 4]),
    ],
  }),
  lvlCfg({
    fieldSize: 17,
    placements: [
      placement(CELL_STATE.BLOCKED, SHAPE.HEX_3, [0, -5, 1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-5, 0]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [-5, 0]),
      placement(CELL_STATE.BLOCKED, SHAPE.HEX_3, [5, 5, 1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [5, 5]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [5, 5]),
      placement(CELL_STATE.BLOCKED, SHAPE.HEX_3, [-5, 5, 1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [5, -5]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [5, -5]),
      placement(CELL_STATE.DROP, SHAPE.HEX_3, [0, 3, 1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.HEX_3, [-6, -6, 4]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.HEX_3, [6, -6, 4]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.LINE_H, 6),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.LINE_H, -6),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [6, 0]),
    ],
    helper: helperCfg({
      maxSteps: 0,
      placement: placement(
        null,
        [SHAPE.LINE_H, SHAPE.LINE_H, SHAPE.LINE_ANGLE, SHAPE.LINE_ANGLE_INV],
        [5, -5, 0, 0]
      ),
    }),
  }),
  // 11 // 13
  lvlCfg({
    fieldSize: 15,
    fieldGeometries: field(SHAPE.HEX),
    catPlacement: placement(
      null,
      [SHAPE.POINT, SHAPE.POINT],
      [
        [0, 0],
        [-2, 4],
      ]
    ),
    placements: [
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_ANGLE, -1),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_ANGLE, 1),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-1, 5]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [0, 5]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [2, -1]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [-3, 1]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [-4, 0]),
    ],
  }),
  lvlCfg({
    catPlacement: placement(null, [SHAPE.POINT], [[0, -1]]),
    fieldGeometries: field(
      [SHAPE.TRIANGLE, SHAPE.HEX],
      [
        [3, 3],
        [0, 0],
      ]
    ),
    placements: [
      //   placement(CELL_STATE.BLOCKED, SHAPE.DOT_LINE_2, [2, 1]),
      placement(CELL_STATE.BLOCKED, SHAPE.DOT_LINE_2, [12, 1]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [0, 0]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [-1, 0]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [1, -2]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [0, -2]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [-1, -2]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [-2, -2]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [0, 1]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [1, -1]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [-1, -1]),
      //   placement(CELL_STATE.FREE, SHAPE.POINT, [0, 5]),
      //   placement(CELL_STATE.FREE, SHAPE.POINT, [0, -5]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-5, -5]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [5, -5]),
      //   placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-2, 5]),
      //   placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-3, 5]),
    ],
  }),
  // 14
  lvlCfg({
    catPlacement: placement(
      null,
      [SHAPE.POINT, SHAPE.POINT],
      [
        [3, 3],
        [-2, -3],
      ]
    ),
    placements: [
      //   placement(CELL_STATE.FREE, SHAPE.LINE_ANGLE_INV, 4),
      placement(CELL_STATE.ERASE, SHAPE.LINE_ANGLE_INV, 4),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_H, -5),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_H, 5),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_ANGLE_INV, 2),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_ANGLE_INV, 6),
      //   placement(CELL_STATE.DROP, SHAPE.HEX_3, [3, 5, 1]),
      placement(CELL_STATE.DROP, SHAPE.HEX_3, [-1, -3, 1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-5, 5]),
      placement(CELL_STATE.DROP, SHAPE.HEX_3, [3, 3, 1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [3, 3]),
    ],
  }),
  // 13 // 15
  lvlCfg({
    fieldSize: 15,
    catPlacement: placement(
      null,
      [SHAPE.POINT, SHAPE.POINT],
      [
        [-1, -1],
        [1, 1],
      ]
    ),
    placements: [
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.SMALL_GRID),
      placement(CELL_STATE.BLOCKED, SHAPE.SPARSE_PAIRS, 1),
      placement(CELL_STATE.DROP, SHAPE.SPARSE_PAIRS, 0),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-4, 5]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [1, 5]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-4, -5]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [1, -5]),
    ],
  }),
  // 15 // 17
  lvlCfg({
    fieldSize: 14,
    catPlacement: placement(
      null,
      [SHAPE.POINT, SHAPE.POINT],
      [
        [3, 0],
        [0, 0],
      ]
    ),
    placements: [
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_V, 4),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_V, 2),
      placement(CELL_STATE.DROP, SHAPE.POINT, [3, -4]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [3, 3]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [2, 4]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [3, 4]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [1, -5]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [2, -5]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [3, -5]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [4, 4]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [4, 4]),
    ],
  }),
  // 16 // 18
  lvlCfg({
    fieldGeometries: field(SHAPE.TRIANGLE_INV),
    fieldSize: 15,
    catPlacement: placement(
      null,
      [SHAPE.POINT, SHAPE.POINT, SHAPE.POINT],
      [
        [0, -3],
        [3, 4],
        [-4, 4],
      ]
    ),
    placements: [
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [0, -5]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-1, -4]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [0, -4]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-1, -3]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [1, -3]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [0, -3]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [1, -2]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-2, -2]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [0, -2]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [-1, -2]),

      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [5, 5]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [4, 5]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [4, 4]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [4, 3]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [3, 5]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [2, 5]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [3, 2]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [2, 4]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [3, 3]),

      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-5, 5]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-4, 5]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-5, 4]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-4, 3]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-3, 5]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-2, 5]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-4, 2]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-3, 4]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-3, 3]),

      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.HEX_3, [1, 1, 1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.HEX_3, [1, -1, 1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.HEX_3, [3, 0, 1]),

      placement(CELL_STATE.FREE, SHAPE.POINT, [0, 1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [1, 1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-1, 1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [0, 2]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-1, 2]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [0, 3]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [0, -3]),
    ],
    helper: helperCfg({
      maxSteps: 0,
      placement: placement(null, [SHAPE.POINT], [[1, -1]]),
    }),
  }),
  // 6 // HARD // 19
  lvlCfg({
    fieldSize: 13,
    catPlacement: placement(
      null,
      [SHAPE.POINT, SHAPE.POINT],
      [
        [1, -1],
        [-1, 1],
      ]
    ),
    placements: [
      placement(CELL_STATE.BLOCKED, SHAPE.DENSE_GRID),
      placement(CELL_STATE.BLOCKED, SHAPE.DOT_LINE_2, [2, 0]),
      placement(CELL_STATE.BLOCKED, SHAPE.DOT_LINE_2, [10, 0]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [1, -1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [0, 0]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [0, 0]),
    ],
  }),
  lvlCfg({
    catPlacement: placement(null, [SHAPE.POINT], [[4, 0]]),
    placements: [
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_H, 1),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_H, -1),
      placement(CELL_STATE.DROP, SHAPE.LINE_H, 0),
      placement(CELL_STATE.FREE, SHAPE.BLOCK_L, [20, 6]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [4, 0]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [4, 0]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.BLOCK_L, [20, 7]),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_ANGLE, 4),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_ANGLE_INV, 4),
      placement(CELL_STATE.FREE, SHAPE.POINT, [5, 0]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [5, 0]),
      placement(CELL_STATE.BLOCKED, SHAPE.DOT_LINE, [0, 7]),
      placement(CELL_STATE.BLOCKED, SHAPE.DOT_LINE, [1, 12]),
      placement(CELL_STATE.FREE, SHAPE.BLOCK_L, [20, 4]),
      placement(CELL_STATE.FREE, SHAPE.BLOCK_L, [4, 7]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-1, 4]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-2, 4]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-3, 4]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-1, 5]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-2, 5]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-3, 5]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-3, 3]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-3, -3]),
    ],
  }),
  // 12 // HARD // 20
  lvlCfg({
    fieldSize: 15,
    fieldGeometries: field(SHAPE.HEX),
    placements: [
      placement(CELL_STATE.DROP, SHAPE.POINT, [0, -2]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [2, 0]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [2, 1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [2, -1]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [0, 2]),
    ],
  }),
  lvlCfg({
    fieldSize: 17,
    placements: [placement(CELL_STATE.DROP, SHAPE.DENSE_GRID)],
  }),
  // 17 // 21
  lvlCfg({
    fieldGeometries: field(SHAPE.HEX),
    fieldSize: 11,
    info: info(
      [2, 4],
      "Meet Center Warp! Teleports the cat to the field's center when stepped on. A second chance to trap your furry escape artist!",
      0,
      POSITIONS.TOP
    ),
    catPlacement: placement(null, [SHAPE.POINT], [[1, -2]]),
    placements: [
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_ANGLE_INV, 2),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_ANGLE_INV, 4),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [2, -3]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.LINE_ANGLE_INV, 3),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [0, 1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-1, 2]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-1, 3]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [-1, 3]),
    ],
  }),
  // 18 // 22
  lvlCfg({
    catPlacement: placement(
      null,
      [SHAPE.POINT, SHAPE.POINT],
      [
        [2, 0],
        [0, 0],
      ]
    ),
    placements: [
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_ANGLE_INV, 3 + 2),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_ANGLE_INV, 5 + 2),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_ANGLE, 3 + 2),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_ANGLE, 5 + 2),
      placement(CELL_STATE.FREE, SHAPE.POINT, [1 + 2, 1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [0 + 2, 1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [1 + 2, -1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [0 + 2, -1]),

      placement(CELL_STATE.CENTER, SHAPE.POINT, [3 + 2, 5]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [-2 + 2, -5]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [2 + 2, -4]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [-2 + 2, 4]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [2 + 2, -3]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [-1 + 2, 3]),
    ],
  }),
  // 19 // 23
  lvlCfg({
    fieldSize: 13,
    fieldGeometries: field(SHAPE.HEX),
    catPlacement: placement(
      null,
      [SHAPE.POINT, SHAPE.POINT, SHAPE.POINT],
      [
        [1, 1],
        [-2, 1],
        [0, -1],
      ]
    ),
    placements: [
      placement(CELL_STATE.CENTER, SHAPE.HEX_OUTLINE, [0, 0, 4]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.HEX_OUTLINE, [0, 0, 3]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [0, 4]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [0, -4]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [3, 2]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-3, 2]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [3, -2]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-3, -2]),
    ],
  }),
  lvlCfg({
    fieldSize: 17,
    fieldGeometries: field(SHAPE.HEX_2),
    placements: [
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.HEX_3, [0, 0, 1]),
      placement(CELL_STATE.CENTER, SHAPE.HEX_OUTLINE, [0, 0, 2]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.HEX_OUTLINE, [0, 0, 4]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.H_LINE, 0),
      placement(CELL_STATE.FREE, SHAPE.POINT, [6, 0]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-6, 0]),
    ],
  }),
  // 20 // 24
  lvlCfg({
    fieldSize: 15,
    catPlacement: placement(
      null,
      [SHAPE.POINT, SHAPE.POINT, SHAPE.POINT, SHAPE.POINT],
      [
        [1, 1],
        [-1, 1],
        [1, -1],
        [-1, -1],
      ]
    ),
    placements: [
      placement(CELL_STATE.DROP, SHAPE.POINT, [4, 3]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [3, 3]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [2, 3]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [2, 2]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [3, 2]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [1, 2]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [-4 + 1, -3]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [-3 + 1, -3]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [-2 + 1, -3]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [-3 + 1, -2]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [-4 + 1, -2]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [-5 + 1, -2]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [4, -3]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [3, -3]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [2, -3]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [2, -2]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [3, -2]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [1, -2]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [-4 + 1, 3]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [-3 + 1, 3]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [-2 + 1, 3]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [-4 + 1, 2]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [-3 + 1, 2]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [-5 + 1, 2]),
    ],
  }),
  lvlCfg({
    fieldSize: 12,
    fieldGeometries: field([SHAPE.TRIANGLE], [null, null]),
    catPlacement: placement(null, [SHAPE.POINT], [[-1, 1]]),
    placements: [
      placement(CELL_STATE.CENTER, SHAPE.LINE_ANGLE, 1),
      placement(CELL_STATE.CENTER, SHAPE.LINE_ANGLE_INV, 5),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [0, 1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [2, -2]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [3, -4]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [3, -4]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [-4, -4]),
      //   placement(CELL_STATE.DROP, SHAPE.LINE_ANGLE_INV, 6),
      //   placement(CELL_STATE.DROP, SHAPE.LINE_ANGLE, 0),
      //   placement(CELL_STATE.DROP, SHAPE.LINE_ANGLE, 5),
      //   placement(CELL_STATE.DROP, SHAPE.LINE_ANGLE_INV, 1),
      placement(CELL_STATE.FREE, SHAPE.POINT, [0, -4]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [0, -3]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-1, -3]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-1, -2]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [1, -2]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-2, -1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [1, -1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-4, -4]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [4, -4]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [-4, -4]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-4, -3]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [3, -3]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-3, -2]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [3, -2]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-3, -1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [2, -1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-1, 2 - 1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [0, 1 - 1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-1, 1 - 1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [0 - 1, 0 - 1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-1 - 1, 0 - 1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [1 - 1, 0 - 1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-1, -1 - 1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [0, -1 - 1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-1, -2 - 1]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [-3, 3]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [-2, 4]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [-3, 4]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [2, 3]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [2, 4]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [3, 4]),
    ],
  }),
  // 21 // 25
  lvlCfg({
    fieldGeometries: field(
      [SHAPE.TRIANGLE, SHAPE.RECTANGLE_H],
      [null, [4, -4]]
    ),
    catPlacement: placement(null, [SHAPE.POINT], [[0, 1]]),
    placements: [
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_ANGLE, 1),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_ANGLE_INV, 6),
      placement(CELL_STATE.FREE, SHAPE.POINT, [0, 5]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-1, 4]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-1, 3]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-2, 2]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [1, 2]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [1, 3]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [0, 4]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [3, 4]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [-3, 4]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [0, 4]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [0, 5]),
      //   placement(CELL_STATE.BLOCKED, SHAPE.POINT, [1, 5]),
    ],
  }),
  // 22 // 26
  lvlCfg({
    fieldGeometries: field(
      [SHAPE.RECTANGLE_V, SHAPE.RECTANGLE_H, SHAPE.RECTANGLE_H],
      [
        [3, 0],
        [4, -4],
        [4, 4],
      ]
    ),
    placements: [
      placement(CELL_STATE.CENTER, SHAPE.POINT, [2, 1]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [2, -1]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [-2, 1]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [-2, -1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-1, -2]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-1, 2]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [0, -2]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [0, 2]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [0, -3]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [0, 3]),
      placement(CELL_STATE.DROP, SHAPE.HEX_3, [4, 4, 1]),
      placement(CELL_STATE.DROP, SHAPE.HEX_3, [-4, 4, 1]),
      placement(CELL_STATE.DROP, SHAPE.HEX_3, [4, -5, 1]),
      placement(CELL_STATE.DROP, SHAPE.HEX_3, [-4, -5, 1]),
    ],
  }),
  // 23 // 27
  lvlCfg({
    catPlacement: placement(
      null,
      [SHAPE.POINT, SHAPE.POINT],
      [
        [1, 0],
        [-1, 0],
      ]
    ),
    fieldGeometries: field(
      [SHAPE.RECTANGLE_V, SHAPE.RECTANGLE_H, SHAPE.RECTANGLE_H],
      [
        [1, 0],
        [4, -4],
        [4, 4],
      ]
    ),
    placements: [
      placement(CELL_STATE.CENTER, SHAPE.POINT, [2, 1]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [2, -1]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [-2, 1]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [-2, -1]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [3, 0]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [-4, 0]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-1, -2]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-1, 2]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [0, -2]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [0, 2]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [0, -3]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [0, 3]),
      placement(CELL_STATE.DROP, SHAPE.HEX_3, [4, 4, 1]),
      placement(CELL_STATE.DROP, SHAPE.HEX_3, [-4, 4, 1]),
      placement(CELL_STATE.DROP, SHAPE.HEX_3, [4, -5, 1]),
      placement(CELL_STATE.DROP, SHAPE.HEX_3, [-4, -5, 1]),

      placement(CELL_STATE.FREE, SHAPE.POINT, [4, 3]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [5, 4]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [4, 5]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [4, 3]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [5, 4]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [4, 5]),

      placement(CELL_STATE.FREE, SHAPE.POINT, [-5, 3]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-5, 5]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-4, 4]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [-4, 4]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [-5, 3]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [-5, 5]),

      placement(CELL_STATE.FREE, SHAPE.POINT, [4, -3]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [5, -4]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [4, -5]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [4, -3]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [5, -4]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [4, -5]),

      placement(CELL_STATE.FREE, SHAPE.POINT, [-5, -3]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-5, -5]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-4, -4]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [-4, -4]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [-5, -3]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [-5, -5]),

      placement(CELL_STATE.CENTER, SHAPE.POINT, [0, 5]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [0, -5]),
    ],
  }),
  // 7 // SUPER HARD // 28
  lvlCfg({
    fieldSize: 15,
    fieldGeometries: field(
      [SHAPE.TRIANGLE, SHAPE.TRIANGLE_INV, SHAPE.HEX],
      [
        [3, 0],
        [3, 3],
        [0, 0],
      ]
    ),
    catPlacement: placement(null, [SHAPE.POINT], [[0, 0]]),
    placements: [
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-3, 0]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [3, 0]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [0, -3]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [0, 3]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-3, 3]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [3, -3]),
    ],
    // info: info(
    //   [7, 7],
    //   "Only one cat, but just five blocks! Careful planning is needed; avoid blocking too close to the center. Test your strategic skills in this challenging level. Happy trapping!"
    // ),
  }),
  // 29
  lvlCfg({
    fieldSize: 13,
    fieldGeometries: field(SHAPE.HEX),
    placements: [
      placement(CELL_STATE.CENTER, SHAPE.LINE_ANGLE, -1),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-2, 4]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [-2, 4]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-4, 0]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [-4, 0]),

      placement(CELL_STATE.CENTER, SHAPE.LINE_ANGLE, 7),
      placement(CELL_STATE.FREE, SHAPE.POINT, [2, -4]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [2, -4]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [4, 0]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [4, 0]),
    ],
  }),
  // 30
  lvlCfg({
    catPlacement: placement(
      null,
      [SHAPE.POINT, SHAPE.POINT],
      [
        [3, 3],
        [-3, 3],
      ]
    ),
    placements: [
      placement(CELL_STATE.ERASE, SHAPE.HEX_3, [-2, 0, 1]),
      placement(CELL_STATE.DROP, SHAPE.HEX_OUTLINE, [3, 3, 1]),
      placement(CELL_STATE.BLOCKED, SHAPE.HEX_OUTLINE, [3, -3, 2]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [-3, 2]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [-4, 3]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [-3, 4]),
      placement(CELL_STATE.ERASE, SHAPE.LINE_ANGLE, 11 + 1),
      placement(CELL_STATE.ERASE, SHAPE.LINE_ANGLE, 12 + 1),
    ],
  }),
  // 24 // 31
  lvlCfg({
    catPlacement: placement(null, [SHAPE.POINT], [[-2, -4]]),
    info: info(
      [7, 7],
      "Get ready for Chaos Shuffle! Once activated, all blocked fields shuffle, causing an unexpected game state. Can you adapt to the new layout? Let's find out!"
    ),
    placements: [
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_ANGLE, 5),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_ANGLE, 3),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-3, -5]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-2, -5]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-2, -5]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [0, 0]),
      placement(CELL_STATE.SHUFFLE, SHAPE.POINT, [0, 0]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [0, 1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [2, 1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [2, 2]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [3, 3]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [3, 4]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [4, 5]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-2, 1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [0, 1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [0, 2]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [1, 3]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [1, 4]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [2, 5]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [0, -1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-1, -2]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-1, -3]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [2, 1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [1, 1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [0, 1]),
    ],
  }),
  // 25 // 32
  lvlCfg({
    placements: [
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_V, 1),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_V, 3),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_V, 5),
      placement(CELL_STATE.SHUFFLE, SHAPE.POINT, [-2, 2]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [-2, -2]),
    ],
  }),
  // 26 // 33
  lvlCfg({
    fieldSize: 16,
    catPlacement: placement(
      null,
      [SHAPE.POINT, SHAPE.POINT, SHAPE.POINT],
      [
        [-4, -2 + 1],
        [0, -2 + 1],
        [4, -2 + 1],
      ]
    ),
    placements: [
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-4, -2 + 1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [0, -2 + 1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [4, -2 + 1]),

      placement(CELL_STATE.CENTER, SHAPE.POINT, [-5, 0 + 1]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [-1, 0 + 1]),
      placement(CELL_STATE.SHUFFLE, SHAPE.POINT, [3, 0 + 1]),

      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-5, -2 + 1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-3, -2 + 1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-3, -3 + 1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-4, -3 + 1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-2 - 1, -1 + 1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [4 + -5, -2 + 1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [4 + -3, -2 + 1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [4 + -3, -3 + 1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [4 + -4, -3 + 1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [4 + -2 - 1, -1 + 1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [4 + -4 - 1, -1 + 1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [8 + -5, -2 + 1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [8 + -3, -2 + 1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [8 + -3, -3 + 1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [8 + -4, -3 + 1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [8 + -2 - 1, -1 + 1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [8 + -4 - 1, -1 + 1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [8 + -4, 0 + 1]),
    ],
    helper: helperCfg({
      maxSteps: 0,
      showPointer: true,
      placement: placement(null, [SHAPE.POINT], [[4, 0]]),
    }),
  }),
  // 27 // 34
  lvlCfg({
    fieldGeometries: field(SHAPE.HEX),
    catPlacement: placement(null, [SHAPE.POINT], [[0, 0]]),
    placements: [
      placement(CELL_STATE.BLOCKED, SHAPE.HEX_3, [0, -6, 3]),
      placement(CELL_STATE.SHUFFLE, SHAPE.POINT, [2, 0]),
      placement(CELL_STATE.SHUFFLE, SHAPE.POINT, [3, -1]),
      placement(CELL_STATE.SHUFFLE, SHAPE.POINT, [3, 1]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [3, 0]),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_ANGLE, 3),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_ANGLE_INV, 3),
    ],
  }),
  // 28 // 35
  lvlCfg({
    catPlacement: placement(
      null,
      [SHAPE.POINT, SHAPE.POINT, SHAPE.POINT],
      [
        [0, -1],
        [2, 3],
        [-2, 3],
      ]
    ),
    fieldGeometries: field(
      [SHAPE.TRIANGLE_INV, SHAPE.HEX],
      [
        [3, 3],
        [0, 0],
      ]
    ),
    placements: [
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [1, 5]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [3, 5]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-1, 5]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-2, 5]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-3, 5]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [3, 2]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [3, 4]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [0, 5]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [4, 0]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [2, 5]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [3, -2]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [2, -4]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [1, -5]),
    ],
  }),
  // 10 // 12
  lvlCfg({
    fieldSize: 17,
    placements: [
      placement(CELL_STATE.DROP, SHAPE.HEX_3, [0, 0, 2]),
      placement(CELL_STATE.SHUFFLE, SHAPE.HEX_OUTLINE, [0, 0, 3]),
      placement(CELL_STATE.SHUFFLE, SHAPE.HEX_OUTLINE_DOTTED, [0, 0, 4]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [0, 0]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [0, 0]),
    ],
  }),
  // 29 // 36
  lvlCfg({
    fieldGeometries: field(
      [SHAPE.RECTANGLE_H, SHAPE.RECTANGLE_V, SHAPE.RECTANGLE_V],
      [
        [3, 0],
        [4, -4],
        [4, 4],
      ]
    ),
    placements: [
      placement(CELL_STATE.SHUFFLE, SHAPE.POINT, [1, 0]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [-1, 0]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [0, 0]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [0, -1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [1, -1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [2, -1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [0, 1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [1, 1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-1, 1]),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_V, 4),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_V, 5),
    ],
  }),
  // 30 // 37
  lvlCfg({
    catPlacement: placement(
      null,
      [SHAPE.POINT, SHAPE.POINT],
      [
        [2, 0],
        [-2, 0],
      ]
    ),
    placements: [
      placement(CELL_STATE.BLOCKED, SHAPE.HEX_OUTLINE, [0, 2, 3]),
      placement(CELL_STATE.SHUFFLE, SHAPE.HEX_3, [0, 2, 2]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [2, 0]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-5, 0]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-1, 1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-2, 1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-3, 1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-4, 1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-5, 1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-5, 2]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-1, -1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-2, -1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-3, -1]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-4, -1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-2, 0]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-3, 0]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-4, 0]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-4, 2]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-3, 2]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-2, 2]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-4, 3]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-3, 3]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-2, 3]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-1, 3]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [-1, 2]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [0, 3]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [0, 4]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [1, 5]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-1, 4]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [1, 5]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [0, 5]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-1, 5]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [1, 2]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [3, 2]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [2, 2]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [3, 3]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [2, 3]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [2, 1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [3, 1]),
    ],
    helper: helperCfg({
      maxSteps: 4,
      showPointer: true,
      loop: false,
      placement: placement(
        null,
        [SHAPE.POINT, SHAPE.POINT, SHAPE.POINT, SHAPE.POINT, SHAPE.POINT],
        [
          [1, 4],
          [2, 5],
          [3, 5],
          [4, 5],
          [4, 4],
        ]
      ),
    }),
  }),
  lvlCfg({
    fieldGeometries: field(SHAPE.HEX_2),
    placements: [
      placement(CELL_STATE.BLOCKED, SHAPE.HEX_3, [0, 0, 3]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [0, 0]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [0, 0]),
      placement(CELL_STATE.FREE, SHAPE.HEX_OUTLINE, [0, 0, 1]),
      placement(CELL_STATE.SHUFFLE, SHAPE.HEX_OUTLINE, [0, 0, 1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [3, 0]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-3, 0]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [2, 0]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-2, 0]),
      //   placement(CELL_STATE.BLOCKED, SHAPE.POINT, [0, 4]),
      //   placement(CELL_STATE.BLOCKED, SHAPE.POINT, [0, -4]),
      //   placement(CELL_STATE.BLOCKED, SHAPE.POINT, [3, 2]),
      //   placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-3, 2]),
      //   placement(CELL_STATE.BLOCKED, SHAPE.POINT, [3, -2]),
      //   placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-3, -2]),
      //   placement(CELL_STATE.FREE, SHAPE.POINT, [0, 0]),
    ],
  }),
  // 31 // 38
  lvlCfg({
    fieldGeometries: field(SHAPE.HEX_2),
    placements: [
      placement(CELL_STATE.SHUFFLE, SHAPE.HEX_3, [0, 0, 3]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [0, 4]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [0, -4]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [3, 2]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-3, 2]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [3, -2]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-3, -2]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [0, 0]),
    ],
  }),
  // 5 // 39
  lvlCfg({
    catPlacement: placement(null, [SHAPE.POINT], [[4, 0]]),
    placements: [
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_H, 1),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_H, -1),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.LINE_H, 0),
      placement(CELL_STATE.FREE, SHAPE.BLOCK_L, [20, 6]),
      placement(CELL_STATE.SHUFFLE, SHAPE.BLOCK_L, [20, 7]),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_ANGLE, 4),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_ANGLE_INV, 4),
      placement(CELL_STATE.FREE, SHAPE.POINT, [5, 0]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [5, 0]),
      placement(CELL_STATE.BLOCKED, SHAPE.DOT_LINE, [0, 7]),
      placement(CELL_STATE.BLOCKED, SHAPE.DOT_LINE, [1, 12]),
      placement(CELL_STATE.FREE, SHAPE.BLOCK_L, [20, 4]),
      placement(CELL_STATE.FREE, SHAPE.BLOCK_L, [4, 7]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-1, 4]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-2, 4]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-3, 4]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-1, 5]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-2, 5]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-3, 5]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-3, 3]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-3, -3]),
    ],
  }),
  // 40
  lvlCfg({
    fieldSize: 16,
    placements: [
      placement(CELL_STATE.BLOCKED, SHAPE.FULL),
      placement(CELL_STATE.FREE, SHAPE.LINE_H, -4),
      placement(CELL_STATE.FREE, SHAPE.LINE_H, -5),
      placement(CELL_STATE.FREE, SHAPE.LINE_H, -6),
      placement(CELL_STATE.FREE, SHAPE.LINE_H, 4),
      placement(CELL_STATE.FREE, SHAPE.LINE_H, 5),
      placement(CELL_STATE.FREE, SHAPE.LINE_H, 0),
      placement(CELL_STATE.FREE, SHAPE.LINE_V, 0),
      placement(CELL_STATE.FREE, SHAPE.LINE_V, -1),
      placement(CELL_STATE.SHUFFLE, SHAPE.HEX_3, [0, 0, 1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [0, 0]),
      placement(CELL_STATE.FREE, SHAPE.LINE_V, 3),
      placement(CELL_STATE.FREE, SHAPE.LINE_H, -3),
      placement(CELL_STATE.FREE, SHAPE.LINE_H, 3),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.LINE_V, 3),
      placement(CELL_STATE.FREE, SHAPE.LINE_V, -4),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.LINE_V, -4),
      placement(CELL_STATE.FREE, SHAPE.LINE_H, 4),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.LINE_H, 4),
      //   placement(CELL_STATE.FREE, SHAPE.LINE_H, -4),
      //   placement(CELL_STATE.NON_BLOCKABLE, SHAPE.LINE_H, -4),
      placement(CELL_STATE.FREE, SHAPE.LINE_H, -4),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.LINE_H, -4),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [2, -3]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [2, 3]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [4, -3]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [4, 3]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [-3, -3]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [-3, 3]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [-5, -3]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [-5, 3]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [-5, 0]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [5, 0]),
    ],
  }),
  lvlCfg({
    fieldSize: 13,
    info: info(
      [7, 7],
      "Meet the 'Instant Trap'! Use this special booster to place blocked fields around the cat instantly, trapping it in a single move. A powerful tool when the cat is close to escaping!",
      0,
      POSITIONS.NONE
    ),
    catPlacement: placement(null, [SHAPE.POINT], [[-3, 0]]),
    placements: [
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_H, -1),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.LINE_H, 0),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_H, 1),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-4, 0]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-4, 0]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [2, 0]),
      placement(CELL_STATE.CATCH, SHAPE.POINT, [2, 0]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [3, -1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [3, 1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [2, -1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [2, 1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [1, -1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [1, 1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [2, -1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [2, 1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [1, -1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [1, 1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [4, 0]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [4, 1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [4, -1]),
    ],
  }),
  // 32 // 41
  lvlCfg({
    catPlacement: placement(
      null,
      [SHAPE.POINT, SHAPE.POINT],
      [
        [1, 0],
        [-1, 0],
      ]
    ),
    placements: [
      placement(CELL_STATE.BLOCKED, SHAPE.SPARSE_PAIRS, 1),
      placement(CELL_STATE.CATCH, SHAPE.POINT, [2, 2]),
      placement(CELL_STATE.CATCH, SHAPE.POINT, [4, 0]),
      placement(CELL_STATE.CATCH, SHAPE.POINT, [-3, -1]),
      placement(CELL_STATE.CATCH, SHAPE.POINT, [-2, -4]),
      placement(CELL_STATE.CATCH, SHAPE.POINT, [0, 4]),
    ],
  }),
  // 33 // 42
  lvlCfg({
    fieldGeometries: field(SHAPE.HEX_2),
    catPlacement: placement(
      null,
      [SHAPE.POINT, SHAPE.POINT],
      [
        [1, 0],
        [-1, 0],
      ]
    ),
    placements: [
      placement(CELL_STATE.BLOCKED, SHAPE.GRID, 0),
      placement(CELL_STATE.CATCH, SHAPE.POINT, [-3, -2]),
      placement(CELL_STATE.CATCH, SHAPE.POINT, [-3, 2]),
      placement(CELL_STATE.FREE, SHAPE.LINE_H, 5),
      placement(CELL_STATE.FREE, SHAPE.LINE_H, -5),
    ],
  }),
  // 34 // 43
  lvlCfg({
    catPlacement: placement(
      null,
      [SHAPE.POINT, SHAPE.POINT, SHAPE.POINT],
      [
        [3, 3],
        [-3, 3],
        [-3, -3],
      ]
    ),
    placements: [
      placement(CELL_STATE.ERASE, SHAPE.HEX_3, [-2, 1, 1]),
      placement(CELL_STATE.CATCH, SHAPE.HEX_OUTLINE, [-3, -3, 1]),
      placement(CELL_STATE.CATCH, SHAPE.HEX_OUTLINE, [3, 3, 1]),
      placement(CELL_STATE.CENTER, SHAPE.HEX_OUTLINE, [3, -3, 1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-3, 2]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [-3, 2]),
    ],
  }),
  // 35 // 44
  lvlCfg({
    catPlacement: placement(
      null,
      [SHAPE.POINT, SHAPE.POINT],
      [
        [3, -3],
        [-2, 3],
      ]
    ),
    placements: [
      placement(CELL_STATE.ERASE, SHAPE.LINE_ANGLE, 4),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_H, -5),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_H, 5),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_ANGLE, 2),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_ANGLE, 6),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [5, -3]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [-3, 1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-5, -5]),
      placement(CELL_STATE.CATCH, SHAPE.POINT, [4, -1]),
    ],
  }),
  lvlCfg({
    fieldSize: 13,
    catPlacement: placement(
      null,
      [SHAPE.POINT, SHAPE.POINT, SHAPE.POINT],
      [
        [-3, 0],
        [3, 3],
        [3, -3],
      ]
    ),
    placements: [
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_H, -1),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.LINE_H, 0),
      placement(CELL_STATE.BLOCKED, SHAPE.LINE_H, 1),
      placement(CELL_STATE.BLOCKED, SHAPE.HEX_3, [3, 3, 1]),
      placement(CELL_STATE.BLOCKED, SHAPE.HEX_3, [-3, 3, 1]),
      //   placement(CELL_STATE.NON_BLOCKABLE, SHAPE.LINE_H, -3),
      //   placement(CELL_STATE.BLOCKED, SHAPE.LINE_H, -2),
      //   placement(CELL_STATE.BLOCKED, SHAPE.LINE_H, 4),
      //   placement(CELL_STATE.NON_BLOCKABLE, SHAPE.LINE_H, 3),
      //   placement(CELL_STATE.BLOCKED, SHAPE.LINE_H, 2),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-4, 0]),
      placement(CELL_STATE.BLOCKED, SHAPE.POINT, [-4, 0]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [2, 0]),
      placement(CELL_STATE.CATCH, SHAPE.POINT, [2, 0]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [3, -1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [3, 1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [2, -1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [2, 1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [1, -1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [1, 1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [2, -1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [2, 1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [1, -1]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [1, 1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [4, 0]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [4, 1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [4, -1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [3, -3]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [3, 3]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [2, -3]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [2, 3]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [3, -3]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [3, 3]),
      placement(CELL_STATE.DROP, SHAPE.POINT, [2, -3]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [2, 3]),
    ],
  }),
  // 38 // 45
  lvlCfg({
    catPlacement: placement(null, [SHAPE.POINT], [[0, -1]]),
    fieldSize: 13,
    fieldGeometries: field(SHAPE.HEX),
    placements: [
      placement(CELL_STATE.CATCH, SHAPE.POINT, [-2, 3]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [3, 0]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [1, -3]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [-2, -3]),
    ],
  }),
  lvlCfg({
    fieldSize: 17,
    fieldGeometries: field([SHAPE.HEX_2], [null]),
    placements: [
      placement(CELL_STATE.DROP, SHAPE.HEX_3, [0, 0, 1]),
      placement(CELL_STATE.SHUFFLE, SHAPE.HEX_3, [0, 0, 2]),
      placement(CELL_STATE.DROP, SHAPE.HEX_3, [0, 0, 3]),
      placement(CELL_STATE.SHUFFLE, SHAPE.HEX_3, [0, 0, 4]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [0, 0]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [0, 0]),
    ],
  }),
  // 39 // 46
  lvlCfg({
    fieldSize: 15,
    fieldGeometries: field(
      [SHAPE.HEX_2, SHAPE.RECTANGLE_H],
      [
        [3, 0],
        [2, 3],
      ]
    ),
    placements: [
      placement(CELL_STATE.CENTER, SHAPE.POINT, [3, 5]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [-2, 5]),
      placement(CELL_STATE.CATCH, SHAPE.POINT, [0, -4]),
    ],
  }),
  lvlCfg({
    fieldSize: 19,
    catPlacement: placement(null, [SHAPE.HEX_OUTLINE_DOTTED], [[0, 0, 4]]),
    placements: [placement(CELL_STATE.CATCH, SHAPE.HEX_OUTLINE, [0, 0, 6])],
  }),
  // 38 // 47
  lvlCfg({
    catPlacement: placement(
      null,
      [SHAPE.POINT, SHAPE.POINT],
      [
        [-2, -2],
        [2, -2],
      ]
    ),
    placements: [
      placement(CELL_STATE.ERASE, SHAPE.HEX_3, [6, 0, 2]),
      placement(CELL_STATE.BLOCKED, SHAPE.HEX_3, [-4, 4, 1]),
      placement(CELL_STATE.BLOCKED, SHAPE.HEX_3, [4, 4, 1]),
      placement(CELL_STATE.DROP, SHAPE.HEX_3, [0, 0, 1]),
      placement(CELL_STATE.CATCH, SHAPE.HEX_3, [4, -4, 1]),
      placement(CELL_STATE.CENTER, SHAPE.HEX_3, [-4, -4, 1]),
    ],
  }),
  // 39 // 48
  lvlCfg({
    catPlacement: placement(null, [SHAPE.SMALL_GRID], 1),
    placements: [
      placement(CELL_STATE.CATCH, SHAPE.HEX_3, [4, -5, 1]),
      placement(CELL_STATE.CATCH, SHAPE.HEX_3, [-4, -5, 1]),
      placement(CELL_STATE.CATCH, SHAPE.HEX_3, [4, 4, 1]),
      placement(CELL_STATE.CATCH, SHAPE.HEX_3, [-4, 4, 1]),
      placement(CELL_STATE.CENTER, SHAPE.LINE_H, 5),
      placement(CELL_STATE.CENTER, SHAPE.LINE_H, -5),
      placement(CELL_STATE.DROP, SHAPE.LINE_H, 2),
      placement(CELL_STATE.DROP, SHAPE.LINE_H, -2),
      placement(CELL_STATE.FREE, SHAPE.POINT, [5, -2]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [5, 2]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-5, -2]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-5, 2]),
    ],
  }),
  // 40 // 49
  lvlCfg({
    fieldSize: 17,
    fieldGeometries: field(SHAPE.HEX_2),
    catPlacement: placement(null, [SHAPE.POINT], [[4, 0]]),
    placements: [
      placement(CELL_STATE.ERASE, SHAPE.HEX_3, [0, 0, 1]),

      placement(CELL_STATE.CENTER, SHAPE.POINT, [5, -1]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [5, 1]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [1, -3]),
      placement(CELL_STATE.CENTER, SHAPE.POINT, [1, 3]),
      placement(CELL_STATE.CATCH, SHAPE.POINT, [3, 3]),
      placement(CELL_STATE.CATCH, SHAPE.POINT, [3, -3]),
    ],
  }),
  // 50
  lvlCfg({
    fieldSize: 17,
    placements: [
      placement(CELL_STATE.BLOCKED, SHAPE.HEX_3, [0, -5, 1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [-5, 0]),
      placement(CELL_STATE.CATCH, SHAPE.POINT, [-5, 0]),
      placement(CELL_STATE.BLOCKED, SHAPE.HEX_3, [5, 5, 1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [5, 5]),
      placement(CELL_STATE.CATCH, SHAPE.POINT, [5, 5]),
      placement(CELL_STATE.BLOCKED, SHAPE.HEX_3, [-5, 5, 1]),
      placement(CELL_STATE.FREE, SHAPE.POINT, [5, -5]),
      placement(CELL_STATE.CATCH, SHAPE.POINT, [5, -5]),
      placement(CELL_STATE.SHUFFLE, SHAPE.HEX_3, [0, 3, 1]),
      // placement(CELL_STATE.NON_BLOCKABLE, SHAPE.HEX_3, [-5, -4, 3]),
      // placement(CELL_STATE.NON_BLOCKABLE, SHAPE.HEX_3, [5, -4, 3]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.HEX_3, [-6, -6, 4]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.HEX_3, [6, -6, 4]),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.LINE_H, 6),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.LINE_H, -6),
      placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [6, 0]),
      // placement(CELL_STATE.NON_BLOCKABLE, SHAPE.POINT, [5, 0]),
    ],
  }),
  // //  41
  //   lvlCfg({
  //     info: info(
  //         [7, 7],
  //         "Behold the 'Wildcard Booster'! When used, it randomly selects and executes one of the four boosters: Scatter Drop, Center Warp, Chaos Shuffle, or Instant Trap. Let luck guide your game!"
  //       ),
  //   }),
];
